// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"76d9e954","732":"474689ca"}[chunkId] + ".chunk.js";
};